import { Link, useNavigate } from "react-router-dom";
import { AdminUsers } from "./components/users";
import { AdminPosts } from "./components/posts";
import { AdminSharing } from "./components/sharing";
import { AdminQrCode } from "./components/codes";
import { AdminImportantObjFile } from "./components/importantObjFile";
import { AdminMobileAsset } from "./components/assets";
import { AdminFormsForm } from "./components/formsForm";
import { AdminFormsDocuments } from "./components/formsDocuments";
import { useContext, useEffect, useState } from "react";
import Context from "../../common/components/utils/context";
import { BubbleV1Service } from "../../common/services/api/api";
import { AdminFormsTeam } from "./components/formsTeam";
import { AdminFormsStructure } from "./components/formsStructure";

export const Admin = ({ page }: IAdminProps) => {
  const navigate = useNavigate();
  const context = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(true);
  // const [error, setError] = useState(false);
  const service = new BubbleV1Service();

  if (!page) {
    navigate("/admin/qr-code");
  }

  useEffect(() => {
    update && fetch().then(() => setUpdate(false));
  }, [update]);

  const fetch = async () => {
    try {
      setLoading(true);
      const userID = context.account?.accountId;
      const company = context.account?.company;
      if (userID) {
        // TODO: role is hardcoded to 0, should be dynamic
        const role = 0;
        const response = await service.encrypt(
          userID,
          company?.companyId,
          role
        );
        const encodedUserId = encodeURIComponent(response.data.userID);
        const encodedCompanyId = encodeURIComponent(response.data.companyID);
        const encodedRoleId = encodeURIComponent(response.data.role);
        context.setCryptedUserID(encodedUserId);
        context.setCryptedCompanyID(encodedCompanyId);
        context.setCryptedRole(encodedRoleId);
      }
    } catch (error) {
      console.error("Error fetching token:", error);
      // setError(true);
    } finally {
      setLoading(false);
    }
  };

  // TODO: Can this go somewhere else or be generated?
  const menu = [
    { id: "AdminUsers", slug: "/admin/users", title: "Users *" },
    { id: "AdminPosts", slug: "/admin/posts", title: "Posts *" },
    { id: "AdminSharing", slug: "/admin/sharing", title: "Sharing *" },
    { id: "AdminQrCode", slug: "/admin/qr-code", title: "Check-In Points" },
    { id: "AdminShapeFiles", slug: "/admin/shape-files", title: "Shape Files" },
    //{ id: "AdminImportantObjFile", slug: "/admin/important-obj-file", title: "Important OBJ File *" },
    {
      id: "AdminMobileAsset",
      slug: "/admin/mobile-asset",
      title: "Mobile Assets",
    },
    {
      id: "AdminFormsForms",
      slug: "/admin/forms",
      title: "Create Custom Form *",
    },
    {
      id: "AdminFormsDocuments",
      slug: "/admin/forms/documents",
      title: "- Documents",
    },
    { id: "AdminFormsTeam", slug: "/admin/forms/team", title: "- Team" },
    {
      id: "AdminFormsStructure",
      slug: "/admin/forms/structure",
      title: "- Company Structure",
    },
    {
      id: "AdminMatterPortFiles",
      slug: "/admin/poi-files",
      title: "3D Models",
    },
    {
      id: "MatterportViewer",
      slug: "/matterport",
      title: "3D Model Placement",
    },
  ];

  return (
    <main className="container mx-auto px-4 py-8 mb-auto relative">
      <div className="flex flex-col md:flex-row items-center md:justify-between py-8">
        <div className="md:w-1/5 flex items-center">
          <img
            alt=""
            src="/img/foundat-icon.png"
            className="inline h-20 w-20 mr-3 rounded-full"
          />
        </div>
        <div className="md:w-4/5">
          <div className="mr-auto"></div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row md:justify-around">
        <div className="md:w-1/5 md:mr-6">
          <ul className="space-y-2 font-medium">
            {!loading &&
              menu.map((item) => (
                <li key={item.id}>
                  <Link
                    to={item.slug}
                    className={`flex items-center p-2 text-gray-500 rounded-lg hover:bg-gray-50 group ${
                      item.id === page?.type.name && "text-gray-900 bg-gray-100"
                    }`}
                  >
                    <span className="ms-3">{item.title}</span>
                  </Link>
                </li>
              ))}
          </ul>
        </div>
        <div className="md:w-4/5">{page}</div>
      </div>
    </main>
  );
};

interface IAdminProps {
  page?: JSX.Element;
}

export {
  AdminUsers,
  AdminPosts,
  AdminSharing,
  AdminQrCode,
  AdminImportantObjFile,
  AdminMobileAsset,
  AdminFormsForm,
  AdminFormsDocuments,
  AdminFormsTeam,
  AdminFormsStructure,
};
